import WebApp from '@twa-dev/sdk';

import { type PlatformEvent } from '../types';

export const trackerAfterEvent = (): PlatformEvent => {
  const loadingSessionId = localStorage.getItem('LOADING_SESSION_ID');

  return {
    type: 'early_loading',
    created: Date.now(),
    user_properties: {
      loading_session_id: loadingSessionId,
      telegram_id: WebApp?.initDataUnsafe?.user?.id,
    },
    event_properties: {
      name: 'after',
      page_load_end: Date.now(),
      platform: WebApp?.platform || 'unknown',
      loading_duration: Date.now() - window.PAGE_LOAD_START,
    },
  };
};
